import { render } from "./TheDetails.vue?vue&type=template&id=8fc58dba&scoped=true"
import script from "./TheDetails.vue?vue&type=script&lang=js"
export * from "./TheDetails.vue?vue&type=script&lang=js"

import "./TheDetails.vue?vue&type=style&index=0&id=8fc58dba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc58dba"]])

export default __exports__